module.exports = __webpack_public_path__ + "static/media/47.5b015dd0.jpg";